import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  summaryWrapper: {
    marginTop: '20px',
    display: 'flex',
    alignItems: 'stretch',
    flexWrap: 'wrap'
  },
  infoContainer: {
    alignItems: 'center',
    boxShadow: palette.shadows.light,
    width: '100%',
    padding: '14px 32px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      // width: '69%',
      width: '100%'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'flex-start'
    }
  },
  info: {
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      paddingTop: '10px',
      flexGrow: '1'
    }
  },
  utilitiesContainer: {
    width: '41%',
    padding: '21px 24px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '31%'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  utilitiesListWrapper: {
    display: 'flex',
    flexGrow: '1',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    height: '100%',
    alignItems: 'center'
  },
  hiddenUtilitiesDesktop: {
    marginLeft: '10px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'none'
    }
  },
  hiddenUtilitiesTablet: {
    display: 'none',
    marginLeft: '10px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'block'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  utilitiesList: {
    display: 'flex',
    '& button': {
      display: 'none'
    },
    [breakpointsFunc.breakpoints.up('sm')]: {
      '& button': {
        display: 'block'
      }
    },
    [breakpointsFunc.breakpoints.up('md')]: {
      '& button': {
        display: 'none'
      },
      '& button:nth-child(1)': {
        display: 'block'
      },
      '& button:nth-child(2)': {
        display: 'block'
      }
    },
    [breakpointsFunc.breakpoints.up('lg')]: {
      '& button': {
        display: 'none'
      },
      '& button:nth-child(1)': {
        display: 'block'
      },
      '& button:nth-child(2)': {
        display: 'block'
      },
      '& button:nth-child(3)': {
        display: 'block'
      },
      '& button:nth-child(4)': {
        display: 'block'
      },
      '& button:nth-child(5)': {
        display: 'block'
      },
      '& button:nth-child(6)': {
        display: 'block'
      }
    }
  }
}));
export default useStyles;